import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

// Used by ThreatCardSkeleton
export const CardWrapper = (theme: any) => ({
  ...(theme.palette.mode === 'dark'
    ? { boxShadow: 'none', border: `1px solid ${theme.palette.divider}` }
    : { boxShadow: '0px 18px 32px 16px rgba(193, 193, 193, 0.16)' }
  ),
  borderRadius: '16px',
  padding: '14px',
  position: 'relative',

  '&:hover': {
    backgroundColor: theme.palette.background.tertiary,
  },
});

// Used by ThreatTable for "no data" messages
export const Span = styled('span')(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.text.disabled,
}));

// Used by ThreatTable for threat name links
export const ThreatDetails = styled(Link)(({ theme }) => ({
  textDecoration: 'none !important',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  '&:visited': {
    color: theme.palette.text.primary,
  },
  '&:hover': {
    color: theme.palette.primary.dark,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.dark,
  },
}));
